<template>
  <div>
    <div class="admin-header">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 align-items-center d-flex justify-content-between">
            <h1 class="white">Media Library</h1>
            <div>
              <input v-on:change="uploadMedia" id="file-input" ref="file" type="file" style="display:none;" />
              <button @click="$refs.file.click()" type="button" class="btn btn-info">Upload New</button>      
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" v-if="processing">
      <div class="row space-loader d-flex align-items-center justify-content-center">
        <b-spinner style="width: 6rem; height: 6rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
    <div class="container section-padding edited-section-pad" v-else>
      <div class="row">
        <MediaLibraryCard v-for="(media, mediaIndex) in mediaLibrary" :key="mediaIndex" v-bind:media="media"
          v-on:delete="deleteMedia" />
      </div>
    </div>
  </div>
</template>

<script>
  import MediaLibraryCard from "@/components/Admin/MediaLibraryCard.vue";
  import api from "../../api/api";
  export default {
    components: {
      MediaLibraryCard,
    },
    data: function () {
      return {
        processing: false,
        mediaLibrary: {},
      };
    },
    mounted: function () {
      this.processing = true;
      api
        .getMediaLibrary()
        .then((res) => {
          //Create dictionary from response
          for (var i = 0; i < res.media.length; i++) {
            this.$set(this.mediaLibrary, res.media[i].id, res.media[i]);
          }
        })
        .finally(() => {
          this.processing = false;
        });
    },
    methods: {
      uploadMedia() {
        this.processing = true;
        api
          .createMedia(this.$refs.file.files[0])
          .then((res) => {
            this.$set(this.mediaLibrary, res.media.id, res.media);
          })
          .finally(() => {
            this.processing = false;
          });
      },
      deleteMedia(id) {
        this.processing = true;
        api
          .deleteMedia(id)
          .then(() => {
            this.$delete(this.mediaLibrary, id);
          })
          .finally(() => {
            this.processing = false;
          });
      },
    },
  };
</script>